import { get } from 'lodash';
import type {
  ApiResponse,
  CCApiResponse,
  ILayoutType,
  ILocation,
  ILocationGroupWithLocations,
} from 'src/interfaces';

export const mapLocationGroups = (
  response: CCApiResponse,
  locations?: ILocation[],
): ILocationGroupWithLocations[] => {
  const layoutTypes = get(response, 'includes.layoutTypes.data', []);

  return response.data.map((item: ApiResponse) =>
    mapLocationGroup(item, layoutTypes, locations),
  );
};

export const mapLocationGroup = (
  locationGroup: ApiResponse,
  layoutTypes: ILayoutType[],
  locations?: ILocation[],
) => {
  return {
    ...locationGroup,
    layoutType: layoutTypes.find(
      (item) => item.id === locationGroup.layout_type_id,
    ),
    locations: locations?.filter((loc) =>
      loc.location_group_id.includes(locationGroup.id),
    ),
  } as ILocationGroupWithLocations;
};
